__turbopack_context__.v({
  "body": "dialogPrivacyChoices-module__ZtFMMq__body",
  "categoryControl": "dialogPrivacyChoices-module__ZtFMMq__categoryControl",
  "categoryDescription": "dialogPrivacyChoices-module__ZtFMMq__categoryDescription",
  "categoryLabel": "dialogPrivacyChoices-module__ZtFMMq__categoryLabel",
  "categoryRow": "dialogPrivacyChoices-module__ZtFMMq__categoryRow",
  "categoryStateLabel": "dialogPrivacyChoices-module__ZtFMMq__categoryStateLabel",
  "categoryText": "dialogPrivacyChoices-module__ZtFMMq__categoryText",
  "defaultActions": "dialogPrivacyChoices-module__ZtFMMq__defaultActions",
  "defaultActionsRow": "dialogPrivacyChoices-module__ZtFMMq__defaultActionsRow",
  "dialogContent": "dialogPrivacyChoices-module__ZtFMMq__dialogContent",
  "fullWidthButton": "dialogPrivacyChoices-module__ZtFMMq__fullWidthButton",
  "gpcDot": "dialogPrivacyChoices-module__ZtFMMq__gpcDot",
  "gpcRow": "dialogPrivacyChoices-module__ZtFMMq__gpcRow",
  "gpcStatus": "dialogPrivacyChoices-module__ZtFMMq__gpcStatus",
  "gpcStatusCentered": "dialogPrivacyChoices-module__ZtFMMq__gpcStatusCentered",
  "rowButton": "dialogPrivacyChoices-module__ZtFMMq__rowButton",
  "summary": "dialogPrivacyChoices-module__ZtFMMq__summary",
});
